import React from 'react';
import mascotCollaborate3 from '../../../../assets/svg/onboarding/mascot-collaborate-3.svg';
import mascotCollaborate4 from '../../../../assets/svg/onboarding/mascot-collaborate-4.svg';

/**
 * @param {Number} currentStep
 * @param {Number} totalSteps
 */

interface BrandMascotCharacterProps {
    currentStep: number;
    totalSteps?: number;
}

const BrandMascotCharacter: React.FC<BrandMascotCharacterProps> = ({ currentStep, totalSteps }) => {
    const mascotSrc = currentStep === 3 ? mascotCollaborate4 : mascotCollaborate3;

    return (
        <div className="brand-mascot-container">
            <img
                src={mascotSrc}
                alt="MatchHat Mascot"
                style={{ width: '80px', height: 'auto' }}
            />
        </div>
    );
};

export default BrandMascotCharacter;